@for (state of config; track state; let i = $index) {
  <div
    class="switch_state"
    [ngClass]="stateClasses[i]"
    (click)="onStateClick(state)"
    role="radio"
    [attr.aria-checked]="activeState === state">
    <span class="switch_state_label">{{state.label | l10n}}</span>
  </div>
}
